export default __webpack_public_path__ + "static/media/ethereum.5337a03f.svg";